import yup from '../../../config/yup';

export const googleBigQueryWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('googleBigQueryWriter'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    credential: yup.string(),
    projectId: yup.string(),
    datasetId: yup.string().required('Dataset ID is required'),
    tableId: yup.string().required('Table ID is required'),
    jobType: yup.string(),
  }),
});
